// @flow
import { StructureItemActionTypes } from './constants';

type StructureItemAction = { type: string, payload: {} | string };

// common success
export const structureItemApiResponseSuccess = (actionType: string, data: any): StructureItemAction => ({
    type: StructureItemActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const structureItemApiResponseError = (actionType: string, error: string): StructureItemAction => ({
    type: StructureItemActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getStructureItem = (id: string): StructureItemAction => ({
    type: StructureItemActionTypes.GET_STRUCTURE_ITEM,
    payload: { id },
});

export const addStructureItem = (structureItem:any): StructureItemAction => ({
    type: StructureItemActionTypes.ADD_STRUCTURE_ITEM,
    payload: structureItem,
})
export const updateStructureItem = (structureItem:any): StructureItemAction => ({
    type: StructureItemActionTypes.UPDATE_STRUCTURE_ITEM,
    payload: structureItem,
})
export const deleteStructureItem = (id:string): StructureItemAction => ({
    type: StructureItemActionTypes.DELETE_STRUCTURE_ITEM,
    payload: { id },
})

export const listStructureItems = (params:any): StructureItemAction => ({
    type: StructureItemActionTypes.LIST_STRUCTURE_ITEMS,
    payload: params,
});

export const setFiltersStructureItems = (params:any): StructureItemAction => ({
    type: StructureItemActionTypes.SET_FILTER_STRUCTURE_ITEMS,
    payload: params,
})

export const resetStructureItems = (): StructureItemAction => ({
    type: StructureItemActionTypes.RESET,
    payload: {},
});

